function validation() {
    var data = $('#booking-form').serialize()
    return $.ajax({
        url: '/api/validate-formdata',
        type: 'GET',
        data: data,
        async: false,
    }).done(function (data) {
        // control de la alerta
        if (data !== false && data.length) {
            $("#tab_alert").show();
            $('#tab_alert ul').empty()
            for(var i = 0; i < data.length; i++){
                $('#tab_alert ul').append('<li>'+data[i]+'</li>');
            }
        } else if(data !== false) {
            $("#tab_alert").hide();
        }
    });
}
